import AppLayout from "../layout/AppLayout"
import QuizApp from "../components/QuizApp/QuizApp"

export default function Quiz(){

    return(
        <>
        <AppLayout>
            <QuizApp />
        </AppLayout>
        </>
    )
}